import { NavMarker } from 'react-rhumb';
import { useHistory } from 'react-router-dom';
import { captureNetworkError } from 'growth-onboarding-reliability/utils/raven';
import AsyncQuickInviteModal from 'growth-invite-components/modals/AsyncQuickInviteModal';
import { inviteYourTeam, quickInviteModal } from 'getting-started-shared-tasks/taskNames';
import { useTaskApi } from 'setup-guide-components/hooks/task';
import { useUserScopes } from '../../selectors/user';
import { jsx as _jsx } from "react/jsx-runtime";
const UserGuideQuickInviteModal = () => {
  const history = useHistory();
  const {
    completeTask
  } = useTaskApi();
  const userScopes = useUserScopes();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "QUICK_INVITE_MODAL_SHOWN",
    children: /*#__PURE__*/_jsx(AsyncQuickInviteModal, {
      dataTestId: "quick-invite-modal",
      onClose: () => history.push('/'),
      onSent: () => {
        if (completeTask) {
          completeTask(inviteYourTeam).catch(captureNetworkError);
          completeTask(quickInviteModal).catch(captureNetworkError);
        }
      },
      scopes: userScopes,
      trackingName: "user guide quick invite modal"
    })
  });
};
export default UserGuideQuickInviteModal;